export class GcpRestoreAccountAttributesInput {
    'serviceAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
